import { render, staticRenderFns } from "./reviewList.vue?vue&type=template&id=6d3eca86&scoped=true&"
import script from "./reviewList.vue?vue&type=script&lang=js&"
export * from "./reviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3eca86",
  null
  
)

export default component.exports